<template>
  <div class="marquee-bar">
    <div
      v-if="startIndex > 0"
      class="marquee-bar__show-more--left"
      @click="prevArticles"
    >
      <i class="arrow left" />
    </div>
    <ul class="marquee">
      <li
        v-for="(article, index) in windowedArticles"
        :key="index"
        class="article"
      >
        <a :href="articleUrl(article.node.url, article.node.languageInCountry)">
          <div
            v-observe-visibility="{callback: (isVisible, entry) => addMoreArticles(isVisible, index), once: true }"
            :style="{ 'background-image': `url(${article.node.thumbnail})` }"
            class="article__image"
            :alt="article.node.titleInCountry || article.node.title"
          />
          <div class="article__description">
            <h3
              v-if="article.node.categories"
              class="article__category"
            >
              {{ $t(article.node.categories[0].name) }}
            </h3>
            <h4 class="article__title" style="-webkit-box-orient: vertical;">
              {{ truncateString(article.node.titleInCountry || article.node.title) }}
            </h4>
          </div>
        </a>
      </li>
    </ul>
    <div
      class="marquee-bar__show-more"
      @click="nextArticles"
    >
      <i class="arrow right" />
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';

export default {
  name: 'ArticleMarqueeComponent',
  props: {
    numArticles: {
      type: Number,
      default: window.innerWidth <= 599 ? 4 : Math.ceil(window.innerWidth / 450),
    },
    locale: {
      type: String,
      default: 'en',
    },
    country: {
      type: String,
      default: 'SG',
    },
    cache: {
      type: Object,
      default: () => ({
        cache: true,
        component: 'article_marquee'
      })
    }
  },
  data() {
    return {
      skipQuery: false,
      articles: [],
      startIndex: -this.numArticles,
      cursor: null,
    };
  },
  computed: {
    windowedArticles() {
      if (this.$isMobile) {
        return this.articles;
      }
      return this.articles.slice(this.startIndex, this.startIndex + this.numArticles);
    },
  },
  watch: {
    articles(newArticles) {
      this.skipQuery = true;
      this.cursor = newArticles.slice(-1)[0].cursor;
    },
  },
  apollo: {
    articles: {
      query: gql`
        query getArticles($num: Int!, $locale: String!, $country: String!, $cursor: String){
          articles(first: $num, after: $cursor, locale: $locale, country: $country) {
            edges {
              node { thumbnail title url
                titleInCountry(country: $country)
                languageInCountry(country: $country)
                categories { name }
              }
              cursor
            }
          }
        }`,
      variables() {
        return {
          num: this.numArticles,
          locale: this.locale,
          country: this.country,
          cursor: this.cursor,
          cache:this.cache
        };
      },
      update(data) {
        if (this.startIndex < 0) {
          this.startIndex = 0;
        } else {
          this.startIndex += (this.numArticles - 1);
        }
        return this.articles.concat(data.articles.edges);
      },
      skip() {
        return this.skipQuery;
      },
    },
  },
  methods: {
    articleUrl(url, language) {
      return `${url}${language ? `/${language}` : ''}`;
    },
    truncateString(string) {
      const cap = 100;
      if (string.length > cap) {
        const trimmedString = string.substr(0, cap);
        const newString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')));
        return `${newString}..`;
      }
      return string;
    },
    nextArticles() {
      if (this.startIndex + this.numArticles <= this.articles.length) {
        this.skipQuery = false;
        this.$apollo.queries.articles.refetch();
      } else {
        this.startIndex += (this.numArticles - 1);
      }
    },
    prevArticles() {
      if (this.$isDesktop) {
        this.startIndex -= (this.numArticles - 1);
      } else {
        document.querySelector('.marquee-bar .marquee').scrollLeft = 0;
        this.startIndex = 0;
      }
    },
    addMoreArticles(visible, index) {
      if (this.$isMobile && index !== 0 && index % (this.numArticles - 1) === 0 && visible) {
        this.skipQuery = false;
        this.$apollo.queries.articles.refetch();
      }
    },
  },
};
</script>
